/** 
 * @file Defines the {@link BET_INTERFACE_BUTTONS} constant 
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/**
 * Content for each bet interface button
 * @type {object}
 * @constant
 * @default
 * @property {interface-button} cash  - Cash button config
 * @property {interface-button} coins - Coins button config
 * @property {interface-button} max   - Max button config
 * @property {interface-button} minus - Minus button config
 * @property {interface-button} plus  - Plus button config
 */
 const BET_INTERFACE_BUTTONS = {

   cash: {

      id:        'cash',
      text:      'Cash',
      translate: true

   },

   coins: {

      id:        'coins',
      text:      'Coins',
      translate: true

   },
   
   max: {

      id:        'max-bet-button',
      text:      'Bet Max',
      translate: true

   },
   
   minus: {

      id:        'bet-minus',
      text:      '-',
      translate: false

   },

   plus: {

      id:        'bet-plus',
      text:      '+',
      translate: false

   }

 }

 export { BET_INTERFACE_BUTTONS }